import { useState, useEffect } from 'react';
import type { StepContentProps } from '~/ui-rocco/multi-step-form';
import { StepContent } from '../StepContent';
import { HdeOptionList } from '../HDEOptionList';
import type { LocationOption } from '../types';

interface EventSelectionData {
    eventId: string | null;
    locationOptions?: LocationOption[];
}

/**
 * Step shown when there are multiple HDE events.
 * Asks the user to select which event they want to register for.
 */
export function EventSelectionStep({
    setIsValid,
    onDataChange,
    initialData,
}: StepContentProps) {
    const data = initialData as EventSelectionData | undefined;
    const locationOptions = data?.locationOptions ?? [];

    const [eventId, setEventId] = useState<string | null>(
        data?.eventId ?? null,
    );

    useEffect(() => {
        const isValid = eventId !== null;
        setIsValid(isValid);
        onDataChange?.({ eventId });
    }, [eventId, setIsValid, onDataChange]);

    return (
        <div className="flex min-h-0 flex-1 flex-col">
            <StepContent>
                <HdeOptionList
                    label="Select an event *"
                    mode="single"
                    options={locationOptions}
                    value={eventId}
                    onChange={(value) => setEventId(value)}
                />
            </StepContent>
        </div>
    );
}
